export const GAME_TYPES = {
  LOCAL: 'LOCAL', // Режим HotSeat
  ONLINE: 'ONLINE', // Режим онлайн-мультиплеера
  REPLAY: 'REPLAY', // Просмотр записи завершенного сетевого матча
}

// Почему партия завершилась раньше последнего раунда. Пишется в состояние
// (gameEndReason) и в историю матча (Match.endReason); null — сыгран последний раунд
export const GAME_END_REASONS = {
  // Все живые игроки покинули обычный сетевой матч: итоги текущего раунда, без наград
  ALL_PLAYERS_LEFT: 'all_players_left',
  // Лидер оторвался от каждого соперника на GAME_END_WIN_POINTS_GAP очков:
  // обычный конец по правилам, с наградами — только раньше последнего раунда
  WIN_POINTS_GAP: 'win_points_gap',
  // Остальные игроки уничтожены полностью (без отрядов и городов), а у
  // уцелевшего больше очков, чем у каждого из них: обычный конец с наградами
  // в конце раунда (см. findLastStandingPlayer)
  LAST_PLAYER_STANDING: 'last_player_standing',
};
